import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart3 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export interface ChartEmptyStateProps {
  message: string;
  icon?: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  actionHref?: string;
  className?: string;
}

/**
 * Standard empty state for charts. Min height 260px, optional icon, message, and action.
 */
export const ChartEmptyState: React.FC<ChartEmptyStateProps> = ({
  message,
  icon,
  actionLabel,
  onAction,
  actionHref,
  className,
}) => {
  return (
    <div
      className={cn(
        'min-h-[260px] flex flex-col items-center justify-center rounded-lg border border-border bg-muted/30 px-4 py-8 text-center',
        className
      )}
    >
      {icon ?? <BarChart3 className="h-10 w-10 text-muted-foreground mb-3" />}
      <p className="text-sm text-muted-foreground max-w-sm">{message}</p>
      {(actionLabel && (onAction || actionHref)) && (
        <div className="mt-4">
          {actionHref ? (
            <Button variant="outline" size="sm" asChild>
              <Link to={actionHref}>{actionLabel}</Link>
            </Button>
          ) : (
            <Button variant="outline" size="sm" onClick={onAction}>
              {actionLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
